var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { VueComponent } from '@progress/kendo-vue-common';
/**
 * The detail-row class of the native Vue Grid by Kendo UI. Defines custom
 * details for each row. Can be applied for building the hierarchy. If `expandField` is
 * set, depending on the current data item and its `expandField` value,
 * the details for each row will be visible or hidden.
 */

/**
 * @hidden
 */

var GridDetailRow =
/** @class */
function (_super) {
  __extends(GridDetailRow, _super);

  function GridDetailRow() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @hidden
   */
  // @ts-ignore


  GridDetailRow.prototype.render = function (h) {
    return null;
  };

  return GridDetailRow;
}(VueComponent);

export { GridDetailRow };